import { render, staticRenderFns } from "./types.vue?vue&type=template&id=4b8bfaf6"
import script from "./types.vue?vue&type=script&lang=js"
export * from "./types.vue?vue&type=script&lang=js"
import style0 from "./types.vue?vue&type=style&index=0&id=4b8bfaf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports